
export class CourseHelper {

    static getCurrentAA(courseCode) {

        // TODO REACT_APP_AA_YEAR: da sistemare: è un pezza. eliminare la chimata a questo metodo
        let aa = parseInt(process.env.REACT_APP_AA_YEAR);

        /* if (
            this.isExArt13FE(courseCode)
        ) {
            aa = 2025;
        }*/

        return aa;
    }

    static isFree(course) {

        let result = false;
        if (course && course.courseType) {
            if (course.courseType.includes('FREE')) {
                result = true;
            }
        }

        return result;
    }

    static isPFU(courseCode) {
        return (courseCode === 'PFU5CFU2' || courseCode === 'PFU5CFU')
    }

    static isOnlyBollo(courseCode) {
        return (this.isPFU(courseCode) || this.isIUL(courseCode));
    }

    static isBando(courseCode) {

        return courseCode.endsWith('BANDO');
    }

    static isAbilitazioni60(courseCode) {

        return (courseCode.startsWith('IUL30ALL2') || courseCode.startsWith('IUL60ALL1')
            || courseCode.startsWith('UM30ALL2') || courseCode.startsWith('UM60ALL1')
            || courseCode.startsWith('RC60ALL1') || courseCode.startsWith('RC30ALL2')
            || courseCode.startsWith('UNT60ALL1') || courseCode.startsWith('UNT30ALL2')
        )
    }

    static isTfaIndire(courseCode) {

        return (courseCode.startsWith('SASU')
        )
    }


    static isAbilitazioni30ManifestoUM(courseCode) {

        return courseCode.startsWith('UM30ALL2')

    }

    static isAbilitazioni30ManifestoUNT(courseCode) {

        return courseCode.startsWith('UNT30ALL2')

    }

    static isAbilitazioni30ManifestoIUL(courseCode) {

        return courseCode.startsWith('IUL30ALL2')

    }

    static isAbilitazioni30ManifestoRC(courseCode) {

        return courseCode.startsWith('RC30ALL2')

    }

    static isAbilitazioni60ManifestoRC(courseCode) {

        return courseCode.startsWith('RC60ALL1')

    }

    static isAbilitazioni60ManifestoUM(courseCode) {

        return courseCode.startsWith('UM60ALL1')

    }

    static isAbilitazioni60ManifestoUNT(courseCode) {

        return courseCode.startsWith('UNT60ALL1')

    }

    static isAbilitazioni60ManifestoIUL(courseCode) {

        return courseCode.startsWith('IUL60ALL1')

    }

    static isPercorsoAbilitante(courseCode) {
        return (courseCode === 'PERCORSI_ABILITANTI')
    }

    static isReggio30CFU(courseCode) {
        return (courseCode === 'RC30CFUART13');
    }


    static isUnicamillus30CFU(courseCode) {
        return (courseCode.startsWith('UM30'));
    }

    static isCFU(courseCode) {
        return (courseCode === 'CS24CFU' || courseCode === 'CSU24CFU' || courseCode === 'PFU5CFU')
    }

    static isTFAReggio(courseCode) {
        return (courseCode.startsWith('TFA_IX_CICLO'));
    }

    static is60CFU(courseCode) {
        return (courseCode.startsWith('RC60CFUALL1') || courseCode.startsWith('RC60ALL1')
            || courseCode.startsWith('UM60CFUALL1') || courseCode.startsWith('UM60ALL1')
            || courseCode.startsWith('UNT60CFUALL1') || courseCode.startsWith('UNT60ALL1')
            || courseCode.startsWith('IUL60CFUALL1') || courseCode.startsWith('IUL60ALL1')
        );
    }

    static is30CFU(courseCode) {
        return (courseCode.startsWith('RC30CFUALL2') || courseCode.startsWith('RC30ALL2')
            || courseCode.startsWith('UM30CFUALL2') || courseCode.startsWith('UM30ALL2')
            || courseCode.startsWith('UNT30CFUALL2') || courseCode.startsWith('UNT30ALL2')
            || courseCode.startsWith('IUL30CFUALL2') || courseCode.startsWith('IUL30ALL2')
        );
    }

    static isCFUAll(courseCode) {
        return (courseCode === 'RC60CFUALL1' || courseCode === 'RC30CFUALL2')
    }

    static isTFAReggioRiservato(courseCode) {
        return (courseCode === 'TFA_IX_CICLO_RISERVATO')
    }

    static isTFASoprannumerariReggio(courseCode) {
        return (courseCode === 'TFA_IX_CICLO_SOPRANNUMERARI_IDONEI')
    }

    static isTFAOrdinarioReggio(courseCode) {
        return (courseCode === 'TFA_IX_CICLO_ORDINARIO')
    }

    static isReggio(courseCode) {
        return (courseCode === 'CSUREGGIO')
    }

    static isReggioBonifico(courseCode) {
        return (courseCode === 'RC30CFUART13'
            || courseCode === 'TFA_IX_CICLO_RISERVATO'
            || courseCode === 'TFA_IX_CICLO_ORDINARIO'
            || courseCode === 'TFA_IX_CICLO_SOPRANNUMERARI_IDONEI'
            || courseCode === 'RCCFUALL'
            || courseCode.startsWith('RC60')
            || courseCode.startsWith('RC30')
            || courseCode.startsWith('RCALL'))
    }

    static isExArt13(courseCode) {
        // if courseCode end with 'ART13' then it is a ART13 course
        return courseCode.endsWith('ART13');
    }

    static isExArt13FE(courseCode) {
        // if courseCode end with 'ART13' then it is a ART13 course
        return (courseCode.endsWith('ART13') || courseCode === 'RC30CFUART13'
            || courseCode === 'CM30CFUART13' || courseCode === 'UM30CFU'
            || courseCode === 'IUL30CFU' || courseCode === 'UNT30CFU');
    }

    static isTchaikovsky30CFU(courseCode) {

        return (courseCode.startsWith('CM30CFU'));
    }

    static isUnitelmaExArt13(courseCode) {

        return (courseCode.startsWith('UNT30CFU'));
    }

    static isUnitelma(courseCode) {

        return (courseCode.startsWith('UNT30') || courseCode.startsWith('UNT60') || courseCode.startsWith('UNTALL') || courseCode.startsWith('UNT_'));
    }

    static isUnitelmaAbilitazione(courseCode) {

        return (courseCode.startsWith('UNT60ALL1')
            || courseCode.startsWith('UNT30ALL2'))
    }

    static isReggioAbilitazione(courseCode) {

        return (courseCode.startsWith('RC30ALL') || courseCode.startsWith('RC60ALL'));
    }

    static isReggioVC(courseCode) {

        return (courseCode.startsWith('RCALL'));
    }

    static isTchaikovsky(courseCode) {

        return (courseCode.startsWith('CM30')
            || courseCode.startsWith('CM60'));
    }

    static isUnicamillus(courseCode) {

        return (courseCode.startsWith('MU') || courseCode.startsWith('MDU')
            || courseCode.startsWith('MP') || courseCode.startsWith('BU')
            || (courseCode.startsWith('CSU') && !courseCode.startsWith('CSUR')) || courseCode.startsWith('PDU')
            || (courseCode.startsWith('PCU') && !courseCode.startsWith('PCUM'))
            || (courseCode.startsWith('PLU') && !courseCode.startsWith('PLUM'))
            || courseCode.startsWith('UPD') || courseCode.startsWith('UPL')
            || courseCode.startsWith('PFU') || courseCode.startsWith('MSLU')
            || courseCode.startsWith('UMALL')
            || courseCode.startsWith('UM30') || courseCode.startsWith('UM60')
            || courseCode.startsWith('UMALL')
        );
    }

    static isUnicamillusPagoPA(courseCode) {
        return (this.isUnicamillus(courseCode) && courseCode.endsWith('BANDO'));
    }

    static isIUL(courseCode) {
        return (
            courseCode.startsWith('IUL30')
            || courseCode.startsWith('IUL60')
            || courseCode.startsWith('IULALL')
        );
    }

    static isIUL30VC(courseCode) {
        return (
            (courseCode.startsWith('IULALL230') || courseCode.startsWith('IULALL430'))
            && (courseCode.endsWith('VC') || courseCode.endsWith('VC_25'))
        );
    }

    static isIUL36VC(courseCode) {
        return (
            courseCode.startsWith('IULALL536')
            && (courseCode.endsWith('VC') || courseCode.endsWith('VC_25'))
        );
    }

    static isUM30VC(courseCode) {
        return (
            (courseCode.startsWith('UMALL230') || courseCode.startsWith('UMALL430'))
            && (courseCode.endsWith('VC') || courseCode.endsWith('VC_25'))
        );
    }

    static isUNTVC(courseCode) {
        return (
            (courseCode.startsWith('UNTALL'))
            && (courseCode.endsWith('VC') || courseCode.endsWith('VC_25'))
        );
    }

    static isUM36VC(courseCode) {
        return (
            courseCode.startsWith('UMALL536')
            && (courseCode.endsWith('VC') || courseCode.endsWith('VC_25'))
        );
    }

    static isVC(courseCode) {
        return (
            courseCode.endsWith('VC_25') || courseCode.endsWith('VC')
        );
    }


    static isDSII(courseCode) {

        let result = false;
        if (courseCode) {
            if (courseCode.startsWith('DS')) {
                let aa = process.env.REACT_APP_AA_YEAR;
                aa--;
                let ends = aa.toString().slice(2, 4)
                if (courseCode.endsWith(ends)) {
                    result = true;
                }
            }
        }

        return result;
    }

    static isBUII(courseCode) {

        let result = false;
        if (courseCode) {
            if (courseCode.startsWith('BU')) {
                let aa = process.env.REACT_APP_AA_YEAR;
                aa--;
                let ends = aa.toString().slice(2, 4)
                if (courseCode.endsWith(ends)) {
                    result = true;
                }
            }
        }

        return result;
    }

    /** */
    static calcDurationByLog(dataActivityLog) {
        let sumDiffTotal = 0;
        let sumDiffPartial = 0;
        let sDate = '';
        let eDate = '';
        let delta = 60 * 10;

        dataActivityLog.forEach((item) => {
            if (sDate === '' && eDate === '') { sDate = item.time; }
            if (sDate !== '' && eDate === '') { eDate = item.time; }

            if (sDate !== '' && eDate !== '') {
                let timeDifference = eDate - sDate;

                if (timeDifference <= delta) {
                    sumDiffPartial += timeDifference
                }
                else {
                    sumDiffTotal += sumDiffPartial;
                    sumDiffPartial = 0;
                }

                sDate = eDate;
                eDate = '';
            }
        });

        return sumDiffTotal;
    } //calcDurationByLog

    static getGradoTFA(courseCode) {
        if (!courseCode) return "";

        switch (true) {
            case courseCode.includes("PRI"):
                return "PRIMARIA";
            case courseCode.includes("SEC1"):
                return "I GRADO";
            case courseCode.includes("SEC2"):
                return "II GRADO";
            default:
                return "";
        }
    }

    static isTFAAbbreviato(courseCode) {
        return courseCode.includes("AB");
    }
}
